import { useNavigate } from 'react-router';

import { generatePortfolioPath } from '../navigation/AllPortfoliosPageNav/utils';

export const useNavigateToPortfolioPage = () => {
  const navigate = useNavigate();

  return (portfolioId: string) => navigate(generatePortfolioPath(portfolioId));
};
